<template>
  <div class="transfer">
    <div>
      <div class="login-loading">
        <div class="loader-inner ball-scale-multiple">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <p>正在跳转请稍后...</p>
    </div>
  </div>
</template>

<script>

import {getWeixInfo} from "@/utils/auth";

export default {
  name: 'transfer',
  data() {
    return{
      userInfo: JSON.parse(getWeixInfo()),
    }
  },
  methods: {
    handleLink(){
      this.$router.replace({path: this.userInfo.IsRegister ? '/equipment/rent': '/bindingMobile', query: {backUrl: 'home'}})
    }
  },
  mounted(){
    this.handleLink()
  }
}

</script>

<style scoped lang="less">
.transfer{
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #fff !important;
  padding: .3rem;
  >div{
    width: 150px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .login-loading{
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }
    p{
      line-height: 1rem;
      font-size: .28rem;
      color: #409EFF;
    }
  }
}
</style>
